import React, { Component, Suspense, useEffect } from 'react'
import { HashRouter, Route, Routes,useNavigate } from 'react-router-dom'
import $ from 'jquery'
import { checkAuth } from './helpers/AdminAuth'
import './scss/style.scss'
import { setNavigate } from './helpers/NavigateHelper'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Customize
const CustomizeLayout = React.lazy(()=>import("./layout/CustomizeLayout"))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const ForgotPassword = React.lazy(() => import('./views/pages/forgotPassword/ForgotPassword'))
const ResetPassword = React.lazy(() => import('./views/pages/resetPassword/ResetPassword'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

  export const PrivateRoute = ({ children }) => {
    const navigate = useNavigate()
    useEffect(()=>{
      console.log("Auth is",checkAuth())
      if(!checkAuth()){
        navigate('/user/login')
      }
    },[])

    return (
      <>
        {children}
      </>
    )
  }

  function NavigationSetter() {
    const navigate = useNavigate();
    setNavigate(navigate);
    return null;
  }

class App extends Component {
  constructor(props){
    super(props)
    window.$ = window.jQuery = $
  }
  render() {
    return (
      <>
          <NavigationSetter/>
          <Routes>
            <Route exact path="*" name="Home" element={
              <PrivateRoute>
                <DefaultLayout/>
              </PrivateRoute>
            } />
            <Route exact path='/customize' name="Customize" element={
              <PrivateRoute>
                <CustomizeLayout/>
              </PrivateRoute>
            }/>
            <Route exact path="/user/login" name="Login" element={<Login />} />
            {/* <Route exact path="/register" name="Register Page" element={<Register />} /> */}
            <Route exact path="/user/forgot-password" name="Forgot Password" element={<ForgotPassword/>}/>
            <Route exact path="/user/reset-password" name="Reset Password" element={<ResetPassword/>}/>
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
          </Routes>
      </>
    )
  }
}

export default App
